import { FC, useState, useEffect } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { usePageTitle } from 'hooks/usePageTitle';

import { Button } from 'components/parts/Button';
import { useGetProgressQuery } from 'store/progress';

import styles from './MissionCheck.module.scss';
import { useMissionKeyword } from 'hooks/useMissionKeyword';
import { useMissionRelatedData } from 'hooks/useMissionRelatedData';
import { useRemoveRubyTags } from 'hooks/useRemoveRubyTags';

function useLocalAssetImagePath(imageUrl: string | undefined) {
  if (!imageUrl) return null;
  const fileName = new URL(imageUrl).pathname.split('/').pop();
  if (!fileName) return null;
  try {
    return require(`components/pages/Area/images/${fileName.replace(/\.png$/, '.webp')}`) ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
}

export const MissionCheck: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const { mission, article } = useMissionRelatedData(Number(id));
  const { lastResult, isSubmittingKeyword, sendKeyword } = useMissionKeyword(id!);
  const [inputKeyword, setInputKeyword] = useState('');
  const [firstTime, setFirstTime] = useState(false);
  const { refetch: refetchProgress } = useGetProgressQuery();
  const [isError, setIsError] = useState(false);
  const [IsCorrectValue, setIsCorrectValue] = useState(false);
  const nazoImagePath = useLocalAssetImagePath(mission.nazo.url);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (inputKeyword) {
      await sendKeyword(inputKeyword);
      if (!firstTime) {
        setFirstTime(true);
        setIsError(!lastResult);
      }
    }
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputKeyword(event.target.value);
  };
  usePageTitle(useRemoveRubyTags(article?.name));

  useEffect(() => {
    const fetchProgressAndNavigate = async () => {
      if (lastResult) {
        setIsCorrectValue(true);
        // 0.5秒待機
        await new Promise(resolve => setTimeout(resolve, 500));

        // 「progress」を取得し、storeを更新
        await refetchProgress();

        // 完了したらnavigateを実行
        navigate(`/mission/answer-result/${id}`);
      }
    };
    fetchProgressAndNavigate();
  }, [lastResult, navigate, id, refetchProgress]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <p className={styles.text}>
            下のミッションをクリアして手に入れたキーワードを報告しよう！
          </p>
          <div className={styles.imageWrap}>
            <img src={nazoImagePath ?? ''} alt="" className={styles.image} />
          </div>
        </div>
        <div className={styles.body}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <label className={styles.formLabel}>
              クリアキーワードを入力<span className={styles.formLabelRequired}>必須</span>
            </label>
            <input
              type="text"
              value={inputKeyword}
              onChange={handleChange}
              placeholder="きーわーど"
              disabled={isSubmittingKeyword}
              className={styles.formInput}
              data-error={!IsCorrectValue && isError}
            />
            {!firstTime ||
              (!lastResult && (
                <p className={styles.formMessage}>クリアキーワードを正確に入力してね</p>
              ))}
            <div className={styles.formSubmit}>
              <Button
                text="答え合わせ"
                buttonType="submit"
                styleType="primary"
                addClass={[styles.spotButton]}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
